import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton,
} from 'react-accessible-accordion';
import scrollIntoView from 'scroll-into-view-if-needed'
import RichText from '../RichText/RichText'
import _ from 'lodash'
import 'url-search-params-polyfill';

const scrollTo = (el) => {
  const fixedNavigation = window.innerWidth < 1000
  // If the navigation is fixed (mobile), then add 75px to
  // the top. Otherwise add 10px.
  const offsetTop = fixedNavigation ? 75 : 10

  scrollIntoView(el, {
    block: 'start',
    behavior: actions => {
      actions.forEach(({ el, top, left }) => {
        el.scrollTop = top - offsetTop
        el.scrollLeft = left
      })
    }
  })
}

const AccordionItemWrapper = ({ title, content, expanded, uuid }) => {
  const ref = React.createRef()

  return (
    <AccordionItem uuid={uuid}>
      <AccordionItemHeading aria-level={4}>
        <AccordionItemButton>
          <div className="title" ref={ref}>
            {title}
            <span className="accordion__arrow" />
          </div>
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
        <RichText body={content} />
      </AccordionItemPanel>
    </AccordionItem>
  )
}

const AccordionWrapper = ({ title, items, small }) => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const hash = window.location.hash
      const hashWithoutTrailingSlash = hash.replace(/\/$/, '');
      const item = _.find(items, (item) => (`#${item.anchor}` === hashWithoutTrailingSlash))

      if (item) {
        const el = document.getElementById(`accordion__heading-${item.id}`);
        el.click()
        scrollTo(el)
      }
    }
  })

  const preExpanded = [];
  const hl = typeof window !== 'undefined'
    ? (new URLSearchParams(window.location.search).get('hl') || '')
    : ''

  _.forEach(items, (item) => {
    item.uuid = item.id
    if (hl) {
      const searchData = []
      searchData.push(item.title)
      searchData.push(item.content.replace(/<[^>]*>?/gm, ''))
      if (searchData.join('').toLowerCase().indexOf(hl) !== -1) {
        preExpanded.push(item.id);
      }
    }
  })

  return (
    <Accordion
      allowZeroExpanded={true}
      preExpanded={preExpanded}
      className={small ? 'accordion small' : 'accordion'}
      onChange={ids => {
        if (!_.isEmpty(ids)) {
          const el = document.getElementById(`accordion__heading-${_.first(ids)}`)
          scrollTo(el)
        }
      }}
      >
      <label className="sr-only">{title}</label>
      {items.map((item) => <AccordionItemWrapper key={item.id} {...item} />)}
    </Accordion>

    // TODO:
    // De update van versie 2.4.5 => 3.0.0 heeft de manier waarop de onChange werkt gewijzigd.
    // Op dit moment wordt er niet gescrolled naar de content van een accordeon item als deze openklapt.
    // Dit moet op een andere manier worden geimplementeerd

    // onChange = {(index) => {
    //   scrollIntoView(document.getElementById('accordion__title-' + index), {
    //     block: 'nearest',
    //     behavior: 'smooth'
    //   })
    // }}>
  )
};

AccordionWrapper.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object),
};
AccordionWrapper.defaultProps = {
  title: "",
  items: [
    {
      title: 'Organisaties waarbij u kunt inloggen met uw DigiD',
      content:
        '<p>Houd uw DigiD up-to-date. Steeds vaker is alleen inloggen met uw gebruikersnaam en wachtwoord niet voldoende. De nieuwste manier om in te loggen is met de DigiD-app via een persoonlijke pincode, net zoals bij een bankpas. Makkelijk en snel.</p><h4>Up-to-date</h4><p>Houd uw DigiD up-to-date. Steeds vaker is alleen inloggen met uw gebruikersnaam en wachtwoord niet voldoende.</p><h5>Up-to-date</h5><p>Houd uw DigiD up-to-date. Steeds vaker is alleen inloggen met uw gebruikersnaam en wachtwoord niet voldoende.</p><h6>Up-to-date</h6><p>Houd uw DigiD up-to-date. Steeds vaker is alleen inloggen met uw gebruikersnaam en wachtwoord niet voldoende.</p>',
    },
    {
      title: 'Machtigen',
      content: '<p>Content</p>',
    },
    {
      title: 'Wonen in het buitenland',
      content: '<p>Content</p>',
    },
  ],
};

export default AccordionWrapper;
